module.exports = false;




//////////////////
// WEBPACK FOOTER
// ./~/detect-node/browser.js
// module id = 670
// module chunks = 0